<div class="wallet-container" #wallets (resized)="onResized($event)">
    <div [class]="'selected-wallet selectable selected wallet third-party-detail ' + walletClass">
        <div class="wallet-content ">
            <div class="icon-check-circle"></div>
            <div class="detail">
                <div class="wallet-icon">
                    <i class="icon-wallet-vt"></i>
                </div>
                <div class="info">
                    <div class="type">{{toFriend.currencyCode}} {{'REQUEST.WALLET' | translate}}</div>
                    <div class="number">{{toFriend.wallet}}</div>
                </div>
                <div class="amount">
                    <div class="number amount-blur">**********</div>
                </div>
            </div>
        </div>


        <div class="thirt-party-name">
            <i class="icon-user-filed"></i>
            <div class="name">{{toFriend.fullName}}</div>
        </div>
    </div>

</div>